import { motion } from "framer-motion";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomCursor from "@/components/CustomCursor";

// ⚠️ Remplace par ton ID Formspree (ex: https://formspree.io/f/xyzabcde → ID = xyzabcde)
const FORMSPREE_ID = "xpqbgweg";

const inputStyle = {
  width: "100%",
  background: "rgba(255,255,255,0.04)",
  border: "1px solid rgba(255,255,255,0.1)",
  borderRadius: 10,
  padding: "13px 16px",
  color: "white",
  fontSize: 14,
  fontFamily: "'Syne', sans-serif",
  outline: "none",
  boxSizing: "border-box",
  transition: "border-color 0.2s",
};

const labelStyle = {
  display: "block",
  fontSize: 12,
  fontWeight: 700,
  color: "rgba(255,255,255,0.5)",
  letterSpacing: "0.08em",
  marginBottom: 8,
};

export default function Contact() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [focused, setFocused] = useState(null);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    try {
      const res = await fetch(`https://formspree.io/f/${FORMSPREE_ID}`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(form),
      });
      if (res.ok) {
        setStatus("success");
        setForm({ name: "", email: "", subject: "", message: "" });
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "#080b14",
      color: "white",
      fontFamily: "'Syne', sans-serif",
      position: "relative",
      overflow: "hidden",
    }}>
        <CustomCursor /> 
      {/* Background */}
      <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, pointerEvents: "none", zIndex: 0 }}>
        <div style={{
          position: "absolute", top: "-10%", right: "20%",
          width: 600, height: 500,
          background: "radial-gradient(ellipse, rgba(124,58,237,0.13) 0%, transparent 70%)",
        }} />
        <div style={{
          position: "absolute", bottom: "0%", left: "0%",
          width: 500, height: 400,
          background: "radial-gradient(ellipse, rgba(6,182,212,0.08) 0%, transparent 70%)",
        }} />
      </div>

      {/* Nav */}
      <motion.nav
        initial={{ opacity: 0, y: -16 }}
        animate={{ opacity: 1, y: 0 }}
        style={{
          position: "fixed", top: 0, left: 0, right: 0, zIndex: 50,
          padding: "18px 32px",
          display: "flex", alignItems: "center", justifyContent: "space-between",
          borderBottom: "1px solid rgba(255,255,255,0.06)",
          background: "rgba(8,11,20,0.85)",
          backdropFilter: "blur(12px)",
        }}
      >
        <button onClick={() => navigate("/")} style={{
          display: "flex", alignItems: "center", gap: 9, background: "none", border: "none", cursor: "pointer",
        }}>
          <div style={{
            width: 32, height: 32, borderRadius: 8,
            background: "linear-gradient(135deg,#7c3aed,#06b6d4)",
            display: "flex", alignItems: "center", justifyContent: "center",
            boxShadow: "0 0 14px rgba(124,58,237,0.5)",
          }}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
              <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
            </svg>
          </div>
          <span style={{ fontWeight: 800, color: "white", fontSize: 13, letterSpacing: "0.06em" }}>MirrorDigital</span>
        </button>
        <button onClick={() => navigate(-1)} style={{
          background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.1)",
          color: "rgba(255,255,255,0.6)", padding: "7px 16px", borderRadius: 8,
          cursor: "pointer", fontSize: 13, fontFamily: "'Syne', sans-serif",
        }}>← Retour</button>
      </motion.nav>

      {/* Content */}
      <div style={{ maxWidth: 640, margin: "0 auto", padding: "120px 24px 80px", position: "relative", zIndex: 1 }}>
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <div style={{
            display: "inline-block", marginBottom: 16,
            padding: "5px 14px", borderRadius: 20,
            background: "rgba(124,58,237,0.15)", border: "1px solid rgba(124,58,237,0.3)",
            fontSize: 12, color: "#a78bfa", letterSpacing: "0.1em", fontWeight: 700,
          }}>CONTACT</div>

          <h1 style={{
            fontSize: "clamp(32px, 5vw, 52px)", fontWeight: 900,
            lineHeight: 1.1, marginBottom: 12,
            background: "linear-gradient(135deg, #fff 0%, rgba(255,255,255,0.6) 100%)",
            WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
          }}>Parlons de votre projet</h1>

          <p style={{ color: "rgba(255,255,255,0.45)", fontSize: 15, lineHeight: 1.7, marginBottom: 48 }}>
            Une question, un partenariat, un retour ? On vous répond sous 24h.
          </p>

          {/* Info cards */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 40 }}>
            {[
              { icon: "✉", label: "Email", value: "contact@mirrordigital.cloud" },
              { icon: "⚡", label: "Réponse", value: "Sous 24h ouvrées" },
            ].map((item, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 + i * 0.1 }}
                style={{
                  padding: "20px 20px",
                  background: "rgba(255,255,255,0.03)",
                  border: "1px solid rgba(255,255,255,0.07)",
                  borderRadius: 14,
                }}
              >
                <div style={{ fontSize: 20, marginBottom: 8 }}>{item.icon}</div>
                <div style={{ fontSize: 11, color: "rgba(255,255,255,0.4)", fontWeight: 700, letterSpacing: "0.08em", marginBottom: 4 }}>{item.label}</div>
                <div style={{ fontSize: 13, color: "rgba(255,255,255,0.7)" }}>{item.value}</div>
              </motion.div>
            ))}
          </div>

          {/* Form */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            style={{
              padding: "36px 36px",
              background: "rgba(255,255,255,0.03)",
              border: "1px solid rgba(255,255,255,0.08)",
              borderRadius: 20,
            }}
          >
            {status === "success" ? (
              <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                style={{ textAlign: "center", padding: "32px 0" }}
              >
                <div style={{
                  width: 64, height: 64, borderRadius: "50%",
                  background: "linear-gradient(135deg,#7c3aed,#06b6d4)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  margin: "0 auto 20px", fontSize: 28,
                  boxShadow: "0 0 30px rgba(124,58,237,0.4)",
                }}>✓</div>
                <h3 style={{ fontSize: 20, fontWeight: 800, marginBottom: 10 }}>Message envoyé !</h3>
                <p style={{ color: "rgba(255,255,255,0.5)", fontSize: 14 }}>On vous répond très bientôt.</p>
                <button
                  onClick={() => setStatus("idle")}
                  style={{
                    marginTop: 24, background: "rgba(255,255,255,0.06)",
                    border: "1px solid rgba(255,255,255,0.1)", color: "white",
                    padding: "10px 20px", borderRadius: 8, cursor: "pointer",
                    fontSize: 13, fontFamily: "'Syne', sans-serif",
                  }}
                >Envoyer un autre message</button>
              </motion.div>
            ) : (
              <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 20 }}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
                  <div>
                    <label style={labelStyle}>NOM</label>
                    <input
                      name="name" value={form.name} onChange={handleChange} required
                      placeholder="Votre nom"
                      onFocus={() => setFocused("name")} onBlur={() => setFocused(null)}
                      style={{ ...inputStyle, borderColor: focused === "name" ? "rgba(124,58,237,0.6)" : "rgba(255,255,255,0.1)" }}
                    />
                  </div>
                  <div>
                    <label style={labelStyle}>EMAIL</label>
                    <input
                      name="email" type="email" value={form.email} onChange={handleChange} required
                      placeholder="votre@email.com"
                      onFocus={() => setFocused("email")} onBlur={() => setFocused(null)}
                      style={{ ...inputStyle, borderColor: focused === "email" ? "rgba(124,58,237,0.6)" : "rgba(255,255,255,0.1)" }}
                    />
                  </div>
                </div>

                <div>
                  <label style={labelStyle}>SUJET</label>
                  <input
                    name="subject" value={form.subject} onChange={handleChange} required
                    placeholder="De quoi s'agit-il ?"
                    onFocus={() => setFocused("subject")} onBlur={() => setFocused(null)}
                    style={{ ...inputStyle, borderColor: focused === "subject" ? "rgba(124,58,237,0.6)" : "rgba(255,255,255,0.1)" }}
                  />
                </div>

                <div>
                  <label style={labelStyle}>MESSAGE</label>
                  <textarea
                    name="message" value={form.message} onChange={handleChange} required
                    placeholder="Décrivez votre demande..."
                    rows={6}
                    onFocus={() => setFocused("message")} onBlur={() => setFocused(null)}
                    style={{
                      ...inputStyle,
                      resize: "vertical",
                      borderColor: focused === "message" ? "rgba(124,58,237,0.6)" : "rgba(255,255,255,0.1)",
                    }}
                  />
                </div>

                {status === "error" && (
                  <p style={{ color: "#f87171", fontSize: 13 }}>
                    Une erreur est survenue. Réessayez ou contactez-nous directement par email.
                  </p>
                )}

                <button
                  type="submit"
                  disabled={status === "loading"}
                  style={{
                    padding: "14px 28px",
                    background: status === "loading"
                      ? "rgba(124,58,237,0.4)"
                      : "linear-gradient(135deg,#7c3aed,#06b6d4)",
                    border: "none", borderRadius: 10, color: "white",
                    fontFamily: "'Syne', sans-serif", fontWeight: 800,
                    fontSize: 14, cursor: status === "loading" ? "not-allowed" : "pointer",
                    letterSpacing: "0.04em",
                    boxShadow: status === "loading" ? "none" : "0 0 24px rgba(124,58,237,0.4)",
                    transition: "all 0.2s",
                  }}
                >
                  {status === "loading" ? "Envoi en cours..." : "Envoyer le message →"}
                </button>
              </form>
            )}
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
}